import { FRAC_CALCULATION_ENABLED_FIELD_UUIDS } from 'src/constants/fieldUuids';

export const normalizeFieldIdentifier = (
  fieldName: string | null | undefined
) => {
  const normalizedFieldName = fieldName
    ?.trim()
    .replaceAll(/\s+/g, ' ')
    .toLowerCase();

  return normalizedFieldName === '' ? undefined : normalizedFieldName;
};

export const formatFieldIdentifier = (
  fieldName: string | null | undefined,
  fallback = ''
) => {
  const normalizedFieldName = normalizeFieldIdentifier(fieldName);

  if (!normalizedFieldName) {
    return fallback;
  }

  return normalizedFieldName
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const isFracCalculationEnabledForFieldUuid = (
  fieldUuid: string | null | undefined
) => {
  if (!fieldUuid) {
    return false;
  }

  return FRAC_CALCULATION_ENABLED_FIELD_UUIDS.has(fieldUuid);
};
